import { Bot, load } from "./bot-loaders"

export interface Member {
    id: number
    audience: number
    contact: string
    isWAPhone: boolean | null
    sourceMap:Record<string, any>
}

export interface Audience {
    id: number
    name: string
    created: Date
    numMembers: number
    members?: Member[]
}

function fixDate(i:Audience):Audience {
    return {...i, created: new Date(i.created)}
}

export async function listAudiences(){
    const list = await load("audiences");
    return (list.result as Audience[]).map(i => fixDate(i));
}

export async function addAudience(audience:Audience){
    const a = await load("audiences/add", {name: audience.name});
    return fixDate(a.result as Audience);
}

export async function loadAudience(id:number):Promise<Audience>{
    const a = await load(`audiences/${id}`);
    return fixDate(a.result as Audience);
}

export async function updateAudience(audience:Audience):Promise<Audience>{
    const a = await load(`audiences/${audience.id}`, {name: audience.name});
    return fixDate(a.result as Audience);
}

export async function deleteAudience(audience:Audience){
    await load(`audiences/${audience.id}/delete`);
}

export async function appendMembers(audience:number, field:string, members:any[]):Promise<Member[]>{
    const a = await load(`audiences/${audience}/members`, {members, contactField: field});
    return a.result;
}

export async function deleteMembers(audience:number, body:{ids:number[]} = null):Promise<boolean>{
    const a = await load(`audiences/${audience}/delete-members`, body);
    return a.result;
}

//app.get("/audiences/:audience(\\d+)/check-members/bot/:id(\\d+)", preventAccess, botMiddleware, checkMemberWA);
//app.get("/audiences/:audience(\\d+)/check-members-task-status/bot/:id(\\d+)", preventAccess, botMiddleware, checkMemberWATaskStatus);

export async function checkMemberRunTask(bot: Bot, audience:number):Promise<TaskStatus>{
    const a = await load(`audiences/${audience}/check-members/bot/${bot.id}`, null, bot.token);
    return a.status;
}

export async function checkMemberTask(bot: Bot, audience:number):Promise<TaskStatus>{
    const a = await load(`audiences/${audience}/check-members-task-status/bot/${bot.id}`, null, bot.token);
    return a.status;
}

export type TaskStatus = {total?: number, done?: number, error?:number, complete?:boolean}